export const portalName = "Brainbird"
export const emailPrefix = "brainbird.co.in"
export const appMode = window.location.hostname === "localhost" ? "development" : "development";
export const docUrl = window.location.hostname === "localhost" ? "development" : "development";
